import { Component, OnInit, ViewChild } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router } from "@angular/router";
import { ControllerService } from "../shared/services/controller.service";

@Component({
    selector: 'app-monitor',
    templateUrl: './monitor.component.html',
    styleUrls: ['./monitor.component.scss'],
    standalone: false
})
export class MonitorComponent implements OnInit {


  code: null
  report: any = []
  dataSource: any

  clientName = ''

  codes: any = []

  clientId = ''

  filterDebounce: any

  displayedColumns = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  columnNames = [
    {
      id: "client",
      value: "Client",
    },
    {
      id: "code",
      value: "Code"
    },
    {
      id: "description",
      value: "Description",
    },
    {
      id: 'user_count',
      value: 'Registered users'
    },
    {
      id: 'expected_users',
      value: 'Expected users'
    },
    {
      id: 'user_percentage',
      value: 'Expected Users %'
    },
    {
      id: 'complete_count',
      value: 'Users completed'
    },
    {
      id: 'percentage_complete',
      value: 'Completion %'
    },
    {
      id: 'expected_completion',
      value: 'Expected completion date'
    },
    {
      id: 'day_difference',
      value: 'Days to completion'
    },
  ];

  constructor(private httpService: HttpService, private router: Router, public controller: ControllerService, private route: ActivatedRoute) {

  }

  async editCode( clientId, theCode ){

    const resp :any = await this.httpService.postAsync("hcode/listCodes", {clientId})
    this.codes = resp.codes

    this.clientName = this.controller.getClientName(clientId)
    this.code = this.codes.find( ({code}) => code == theCode.trim() )
  }

  closeCodeDetail( event ) {
    this.code = null
    this.fetchReport()

  }

  filter( event ){

    if( this.filterDebounce ){
      window.clearTimeout( this.filterDebounce )
    }

    this.filterDebounce = window.setTimeout( () => {
      this.dataSource.filter = event.target.value.trim()
    }, 250 )
  }

  skeletonRows: number[][] = [];
  loading = false;

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchReport( ){
    this.loading = true;
    this.generateSkeletonRows();

    try {
      this.report = await this.httpService.getAsync("report/monitor")
      this.dataSource.data = this.report
    } finally {
      this.loading = false
    }
  }

  async fetchClients( ){
    try{
      const clients = await this.httpService.postAsync("hclient/listClients", {})
      this.controller.setClients( clients )
    }catch( e ){
      if( e.status == 402 ){
        this.controller.redirectToSignIn()
        return
      }
    }
  }

  async ngOnInit() {
    if( this.controller.getClients().length == 0 ){
      await this.fetchClients()
    }

    this.displayedColumns = this.columnNames.map(x => x.id).concat(['editCode']);
    this.dataSource = new MatTableDataSource(this.report);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch(property) {
        case 'percentage_complete':
        case 'user_percentage':
          return parseFloat(item[property]);
        default:
          return item[property];
      }
    };

    this.fetchReport()
  }

}
